import { ApiError, requestJson, type ApiEnvelope } from '@shared/api/http';
import type {
  IdentityVersionRequest,
  PublicSummaryBatchResult,
} from './types';

export async function fetchPublicSummaries(
  users: IdentityVersionRequest[],
  baseUrl?: string,
): Promise<PublicSummaryBatchResult[]> {
  if (users.length === 0 || users.length > 200) {
    throw new Error('Public identity batch must contain between 1 and 200 users');
  }
  const envelope = await requestJson<ApiEnvelope<{ results: PublicSummaryBatchResult[] }>>(
    '/users/public-summaries/batch',
    {
      method: 'POST',
      baseUrl,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ users }),
    },
  );
  if (envelope.status && envelope.status !== 'Success') {
    throw new ApiError(
      envelope.message ?? 'Failed to load public identities',
      envelope.statusCode ?? 500,
      envelope,
    );
  }
  if (!Array.isArray(envelope.data?.results)) {
    throw new ApiError('Public identity batch response is malformed', 500, envelope);
  }
  return envelope.data.results;
}
